module.exports = __webpack_public_path__ + "media/images/logo_gegenrecht-cacfa6ac.svg";